import { Avatar as ChakraAvatar, AvatarGroup as ChakraAvatarGroup } from '@chakra-ui/react';
import * as React from 'react';

export interface AvatarProps extends ChakraAvatar.RootProps {
	fallback?: React.ReactNode
	icon?:     React.ReactElement
	loading?:  ImageProps['loading']
	name?:     string
	src?:      string
	srcSet?:   string
}

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(function Avatar(props, ref) {
	const {
		children, fallback, icon, loading, name, src, srcSet, ...rest
	} = props;

	return (
		<ChakraAvatar.Root ref={ref} {...rest}>
			<ChakraAvatar.Fallback name={name}>
				{icon || fallback}
			</ChakraAvatar.Fallback>
			<ChakraAvatar.Image loading={loading} src={src} srcSet={srcSet} />
			{children}
		</ChakraAvatar.Root>
	);
});

export const AvatarGroup = ChakraAvatarGroup;
